// Carry Roll SensitivityChart — per-input distance sensitivities (7.7).

import { useMemo } from 'react';
import { useRequest } from '../../store/selectors';
import { sensitivity } from '@carry-roll/shared-logic';
import { HelpTooltip } from '../calculator/HelpTooltip';

export function SensitivityChart() {
  const request = useRequest();
  const data = useMemo(() => sensitivity(request), [request]);

  const maxAbs = Math.max(...data.map((d) => Math.abs(d.dCarryPerUnit)), 1);

  return (
    <div data-testid="sensitivity-chart">
      <h3 className="subsection-title inline-flex items-center">
        Sensitivity analysis
        <HelpTooltip label="Sensitivity analysis">Finite-difference estimate: carry change (m) per one-unit change in each input, around the current values.</HelpTooltip>
      </h3>
      <p className="text-sm mb-3" style={{ color: 'var(--color-text-muted)' }}>
        Change in carry (m) per unit input change.
      </p>
      <div className="flex flex-col gap-2">
        {data.map((d) => {
          const widthPct = (Math.abs(d.dCarryPerUnit) / maxAbs) * 100;
          const isPositive = d.dCarryPerUnit >= 0;
          return (
            <div key={d.parameter} data-testid={`sensitivity-${d.parameter.toLowerCase().replace(/\s+/g, '-')}`}>
              <div className="flex justify-between text-sm">
                <span>{d.parameter}</span>
                <span>
                  {d.dCarryPerUnit > 0 ? '+' : ''}
                  {d.dCarryPerUnit} m/{d.unit}
                </span>
              </div>
              <div
                style={{
                  height: '8px',
                  background: 'var(--color-border)',
                  borderRadius: '4px',
                  marginTop: '2px',
                }}
              >
                <div
                  style={{
                    width: `${widthPct}%`,
                    height: '100%',
                    borderRadius: '4px',
                    background: isPositive ? 'var(--color-total)' : 'var(--color-danger)',
                  }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
